class ProductItemV2 extends HTMLElement {
  connectedCallback() {
    this._imageLink    = this.querySelector('.piv2__image-link');
    this._image        = this.querySelector('.piv2__image');
    this._titleLink    = this.querySelector('.piv2__title-link');
    this._title        = this.querySelector('.piv2__title');
    this._moreLink     = this.querySelector('.piv2__swatch--more');
    this._swatches     = Array.from(this.querySelectorAll('.piv2__swatch:not(.piv2__swatch--more)'));
    this._productTitle = this.dataset.productTitle || '';

    if (!this._swatches.length) return;

    this._swatches.forEach((swatch) => {
      swatch.addEventListener('click', (e) => {
        e.preventDefault();
        this._selectSwatch(swatch);
      });
    });

    this._swatches.forEach((swatch, index) => {
      swatch.addEventListener('keydown', (e) => {
        let targetIndex = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          targetIndex = (index + 1) % this._swatches.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          targetIndex = (index - 1 + this._swatches.length) % this._swatches.length;
        }
        if (targetIndex !== null) {
          this._swatches[targetIndex].focus();
          this._selectSwatch(this._swatches[targetIndex]);
        }
      });
    });

    const initialActive = this.querySelector('.piv2__swatch--active');
    if (initialActive) {
      this._applySwatchState(initialActive, false);
    }
  }

  _selectSwatch(swatch) {
    if (swatch === this._activeSwatchEl) return;
    this._applySwatchState(swatch, true);
  }

  _applySwatchState(swatch, animate) {
    const href          = swatch.dataset.href;
    const featuredImage = swatch.dataset.featuredImage;
    const value         = swatch.dataset.value || '';

    this._swatches.forEach((s) => {
      s.classList.remove('piv2__swatch--active');
      s.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('piv2__swatch--active');
    swatch.setAttribute('aria-pressed', 'true');

    this._activeSwatchEl = swatch;

    if (href) {
      if (this._imageLink) this._imageLink.setAttribute('href', href);
      if (this._titleLink) this._titleLink.setAttribute('href', href);
      if (this._moreLink)  this._moreLink.setAttribute('href', href);
    }

    if (value && this._title) {
      this._title.textContent = `${this._productTitle} - ${value}`;
    }

    if (featuredImage && this._image) {
      if (animate) {
        this._crossfadeImage(featuredImage);
      } else {
        this._image.src = featuredImage;
      }
    }

    this._updatePrice(swatch);
    this._updateAtc(swatch);
  }

  _crossfadeImage(newSrc) {
    const img = this._image;
    img.style.opacity = '0';
    img.removeAttribute('srcset');
    img.src = newSrc;
    img.onload = () => {
      img.style.transition = 'opacity 0.25s ease';
      img.style.opacity = '1';
    };
  }

  _updatePrice(swatch) {
    const price        = parseInt(swatch.dataset.price);
    const comparePrice = parseInt(swatch.dataset.comparePrice);
    const wrapper      = this.querySelector('.piv2__price-wrapper');
    if (!wrapper) return;

    const formatMoney = (cents) => {
      const moneyFormat = window.themeVariables.settings.moneyFormat;
      return moneyFormat.replace('{{amount}}', (cents / 100).toFixed(2));
    };

    if (comparePrice > price) {
      wrapper.innerHTML = `
        <span class="piv2__price piv2__price--sale" aria-label="Sale price">${formatMoney(price)}</span>
        <span class="piv2__price piv2__price--compare" aria-label="Regular price"><s>${formatMoney(comparePrice)}</s></span>
      `;
    } else {
      wrapper.innerHTML = `
        <span class="piv2__price" aria-label="Regular price">${formatMoney(price)}</span>
      `;
    }
  }

  _updateAtc(swatch) {
    const available   = swatch.dataset.available === 'true';
    const soldOutText = 'Sold Out';
    const atcText     = 'Add to Cart';

    this.querySelectorAll('.piv2__atc-btn').forEach((btn) => {
      btn.disabled = !available;
      btn.setAttribute('aria-disabled', String(!available));
      btn.textContent = available ? atcText : soldOutText;
    });

    this.querySelectorAll('.piv2__variant-id').forEach((input) => {
      if (swatch.dataset.variantId) {
        input.value = swatch.dataset.variantId;
      }
    });
  }
}

customElements.define('product-item-v2', ProductItemV2);